module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1PMf5i/tc-custom/9781452126623.jpg?1720805320982",
      "alt": "This image is the cover for the book Grill Every Day"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Grill Every Day\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The award-winning cookbook author delivers a master class on weeknight grilling, with 125 recipes plus essential grill maintenance and meal planning tips.")]), _c('br'), _c('br'), _vm._v("Grilling isn’t just for weekends anymore. In her newest grilling cookbook, Diane Morgan makes a compelling case for using grills every night, complete with 125 recipes and the promise of less dishwashing. For novice grillers, she includes information on different types of grills, cleaning, safety, and tools."), _c('br'), _c('br'), _vm._v("Mouthwatering recipes include meat and veggie entrees, side dishes, and even flame-broiled desserts like Bananas Slicked with Rum and Molasses. If that’s not enough, she’s even added The Grill Planner, a chapter devoted to ensuring that Tuesday’s leftover ingredients from Shrimp and Pineapple Skewers with Garlic and Cilantro Drizzle will become Wednesday’s Pineapple, Shrimp, and Anaheim Chile Salad.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Diane Morgan, E. J. Armstrong\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Diane Morgan is a cookbook author and food writer living in Portland, Oregon. Her books include Salmon, Dressed to Grill, and The Thanksgiving Table.E.J. Armstrong is a Seattle-based food photographer.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0